import React from 'react';
import ModalWrapper from "./ModalWrapper";
const MaterialSelect = ({onClose,list,active,setMaterial,title,notxt})=>{
    return <ModalWrapper
        onClose={onClose}
        title={title}
    >
        <div className="material-select-block">
            {list.map(m=>(
                <div
                    className={m===active?'material-item material-item_active':'material-item'}
                    key={m.uuid}
                    style={{backgroundImage: 'url(' + m.userData.PICT + ')'}}
                    onClick={()=>{setMaterial(m);onClose()}}
                >
                    <span>{(notxt)?'':m.userData.NAME}</span>
                </div>
            ))}
        </div>
    </ModalWrapper>
}
export default MaterialSelect
